import '../Assets/Styles/register.css';
import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { ConfirmPopup } from 'primereact/confirmpopup';

// Actions
import * as AppActions from '../Store/Actions/App';

import { hasRight } from '../Utils/rights';

const TopMenu = (props) => {
  const {
    op,
    confirm,
    masterUser,
    userRights,
    currentCompanyStatus, // <— vamos ler do store
  } = props;

  const navigate = useNavigate();

  const handleNav = (path) => {
    navigate(path);
    op?.current?.hide();               // fecha o overlay
    document.activeElement?.blur();    // tira foco do botão
  };

  return (
    <>
          <div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}}>
            <Button severity="secondary" text label="Painel"
              style={{height:"42px",width:"100%",borderRadius:"0"}}
              onClick={() => handleNav("/admin/dashboard")}
            />
          </div>

      {masterUser && (
        <>

          {hasRight(userRights, "listAgencies") &&
          <>
          <div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}}>
            <Button severity="secondary" text label="Agências"
              style={{height:"42px",width:"100%",borderRadius:"0"}}
              onClick={() => handleNav("/admin/agencies")}
            />
          </div>
          </>
          }

          {hasRight(userRights, "listApprovalAgencies") &&
          <>		
          <div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}}>
            <Button severity="secondary" text label="Fila de aprovação"
              style={{height:"42px",width:"100%",borderRadius:"0"}}
              onClick={() => handleNav("/admin/agenciesApproval")}
            />
          </div>
          </>
          }

        </>
      )}

      {(currentCompanyStatus === 1 || masterUser) && (
        <>

          <div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}}>
            <Button severity="secondary" text label="Perfil do usuário"
              style={{height:"42px",width:"100%",borderRadius:"0"}}
              onClick={() => handleNav("/admin/userProfile")}
            />
          </div>

          <div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}}>
            <Button severity="secondary" text label="Perfil da agência"
              style={{height:"42px",width:"100%",borderRadius:"0"}}
              onClick={() => handleNav("/admin/agencyProfile")}
            />
          </div>

          {(masterUser && hasRight(userRights, 'manageUsers')) && (
            <>
            <div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}}>
              <Button severity="secondary" text label="Usuários Master"
                style={{height:"42px",width:"100%",borderRadius:"0"}}
                onClick={() => handleNav("/admin/masterUsers")}
              />
            </div>
            <Divider style={{margin: "0.25rem 0"}} />
            </>
          )}

          {hasRight(userRights, 'manageUsers') && (
            <div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}}>
              <Button severity="secondary" text label="Usuários"
                style={{height:"42px",width:"100%",borderRadius:"0"}}
                onClick={() => handleNav("/admin/users")}
              />
            </div>
          )}
            
         {hasRight(userRights, 'listCustomers') &&
           <>
            {/*<div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}}>
              <Button severity="secondary" text label="Clientes"
                style={{height:"42px",width:"100%",borderRadius:"0"}}
                onClick={() => handleNav("/admin/customers")}
              />
            </div>*/}
          </>
         }          

          {hasRight(userRights, 'listBookings') && (
            <div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}}>
              <Button severity="secondary" text label="Reservas"
                style={{height:"42px",width:"100%",borderRadius:"0"}}
                onClick={() => handleNav("/admin/reservations")}
              />
            </div>
          )}

          {(masterUser || hasRight(userRights, 'listQuotes')) && (
            <div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}}>
              <Button severity="secondary" text label="Cotações"
                style={{height:"42px",width:"100%",borderRadius:"0"}}
                onClick={() => handleNav("/admin/cotacoes")}
              />
            </div>
          )}

         {hasRight(userRights, 'generateReport') &&
           <>
            {/*<div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}}>
              <Button severity="secondary" text label="Relatórios"
                style={{height:"42px",width:"100%",borderRadius:"0"}}
                onClick={() => handleNav("/admin/reports")}
              />
            </div>*/}
          </>
         }       


        </>
      )}

      {masterUser && (
        <>
          {/*
          <div style={{width:"100%",backgroundColor:"#F8F8F8",marginBottom:"2px",fontWeight:"600",display:"flex",alignItems:"center"}}>
            <Button severity="secondary" text label="Configurações"
              style={{height:"42px",width:"100%",borderRadius:"0"}}
              onClick={() => handleNav("/admin/configurations")}
            />
          </div>
          */}
        </>
      )}

      <ConfirmPopup />
      <Button
        label="Fazer logoff"
        className="mR10"
        style={{height:"42px",width:"100%",borderRadius:"0"}}
        onClick={(e) => { confirm(e); }}
      />
    </>
  );
};

const mapStateToProps = (store) => ({
  dialog: store.appReducer.dialog,
  masterUser: store.appReducer.masterUser,
  userRights: store.appReducer.userRights,
  currentCompanyStatus: store.appReducer.currentCompanyStatus, // <— garante a prop
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...AppActions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TopMenu);
